import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Popover.scss'
import { SlideIn } from '../Transitions'
import { Popper, Arrow } from 'react-popper'

const Popover = ({ children, style, placement, modifiers, light }) => {
	return (
		<SlideIn from={'top'}>
			<Popper
				placement={placement ? placement : 'bottom'}
				styleName="popper"
				style={style}
				modifiers={modifiers}
				className={light ? styles.light : ''}
			>
				<Arrow styleName="popper__arrow" />
				<div>{children}</div>
			</Popper>
		</SlideIn>
	)
}
export default CSSModules(Popover, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Overlay/Popover.js